<template>
  <validation-observer
    v-if="!isAdditional"
    v-show="isRenderAfterFullfilled"
    v-slot="observer"
    slim
  >
    <form-section
      :id="questionId || 'kept-address'"
      :validated="formObserver.validated"
      v-bind="observer"
    >
      <form-row :label="title || `Is the ${productName === 'car' ? productName : 'vehicle'} kept at this address?`">
        <validation-provider
          v-slot="{ failed }"
          :vid="`${stepId}_kept-address`"
          name="Kept Address"
          rules="required"
        >
          <radio
            v-model="questionData.keptAddress"
            :data-test="fieldTrackerId.address"
            :name="`${stepId}.kept-address`"
            :items="constants.YES_NO"
            :error="failed"
          />
        </validation-provider>
      </form-row>

      <template v-if="questionData.keptAddress === false">
        <form-row :question="subtitle || `Please enter the postcode of the location where the ${productName === 'car' ? productName : 'vehicle'} is kept`">
          <validation-provider
            v-slot="{ errors }"
            :vid="`${stepId}_kept-postcode`"
            name="Kept Address"
            :rules="postcodeCustomRules"
          >
            <qz-text-field
              v-model.trim="questionData.keptPostcode"
              :data-test="fieldTrackerId.postcode"
              :placeholder="postcodePlaceholder"
              :error-messages="errors"
              :maxlength="inputCharsLimiters.POSTCODE_MAX"
              @keyup="helpers.limitInputChars(questionData, 'keptPostcode', inputCharsLimiters.POSTCODE_MAX)"
              @input="questionData.keptPostcode = questionData.keptPostcode.toUpperCase()"
            />
          </validation-provider>
        </form-row>
      </template>
    </form-section>
  </validation-observer>
</template>

<script>
import QuestionBase from './Base';
import { snakeCase } from 'lodash';

export default {
  name: 'question-kept-address',
  extends: QuestionBase,
  data () {
    return {
      fields: ['keptPostcode', 'keptAddress'],
    };
  },
  watch: {
    'questionData.keptAddress' (val) {
      if (val) {
        this.questionData.keptPostcode = null;
      }
    },
  },
  computed: {
    postcodePlaceholder () {
      return this.helpers.getPostcodeExample(this.config.customValidations?.postcode?.startsWith);
    },
    postcodeCustomRules () {
      if (!this.config.customValidations?.postcode) return 'postcode';

      // hasStartsWithValidation must be always 'false' no metter how custom validation rules come from back-end for this question
      return { postcode: { ...this.config.customValidations.postcode, hasStartsWithValidation: false } };
    },
    fieldTrackerId () {
      return {
        address: snakeCase(this.questionFields.keptAddress),
        postcode: snakeCase(this.questionFields.keptPostcode),
      };
    },
  },
};
</script>
